/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo, useState } from 'react';

import { CreateTicketControlProps } from '../types';
import { ChooseTicketType } from './ChooseTicketType';
import { CreateTicket } from './CreateTicket';

export const TicketCreationControl = memo<CreateTicketControlProps>(({ onSuccess, onClose }) => {
  const [requestType, setRequestType] = useState<{
    id: string;
    name: string;
  } | null>(null);

  return !requestType ? (
    <ChooseTicketType onClose={onClose} setRequestType={setRequestType} />
  ) : (
    <CreateTicket requestType={requestType} setRequestTypeId={setRequestType} onSuccess={onSuccess} onClose={onClose} />
  );
});
